export const getSectionSlugBySectionId = (preparedSlugList, sectionId) => {
  if (preparedSlugList && preparedSlugList.hasOwnProperty(sectionId)) {
    const slug = preparedSlugList[sectionId];
    // SEO may return null for unpublished / fake strategy sections.
    return slug || sectionId;
  }

  return sectionId;
};

export const stockAnalysisCategoryToSectionMapping = {
  stock_analysis_category_morning_brief: "section-morning-brief",
  stock_analysis_category_technical_analysis: "section-investment-scenarios",
  stock_analysis_category_financial_analysis: "section-fundamental-analysis",
  stock_analysis_category_video_analysis: "section-video-analysis",
  stock_analysis_category_short_technical_analysis:
    "section-squaber-team-analysis",
  insider_analysis_category_analysis: "section-insider-analysis",
  insider_analysis_category_recommendation: "section-insider-recommendations",
};
